import { fetcher } from '@commenda/utils';

import { TUpdateBillingPriceParams } from './types';

export const updateBillingPrice = async (priceId: string, params: TUpdateBillingPriceParams) => {
  const response = await fetcher(`commenda-billing/catalog/prices/${priceId}`, {
    method: 'PATCH',
    body: params,
  });

  return response;
};
